import { msg } from '@lingui/macro'
import { Model } from 'sunlife-domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const ensureLinerForTanThrough = configuratorInterface.transformerBuilder.when
  .entity(Model.Shorts.types)
  .modified({ atFields: ['fabric'] })
  .and(ctx => ctx.update.stateDelta.fabric === 'tan through' && ctx.getOld$Root().liner === 'none')
  .then.applySideEffect(ctx => {
    return [
      configuratorInterface.updates.DomainEntityModification({
        entityId: ctx.getOld$Root().id,
        stateDelta: {
          liner: 'mesh',
        },
        updateTag: 'ensureLinerForTanThrough',
        hint: msg`Liner has been added as it is required for the tan through fabric`,
      }),
    ]
  })
  .build('ensureLinerForTanThrough')
